export function GuestBanner({ onSignUp }: { onSignUp: () => void }) {
  return (
    <div className="sa-guest-banner">
      <span>
        You are reading as a guest. Guest chats don't remember previous questions, and
        close with this tab.
      </span>
      <button
        onClick={onSignUp}
        style={{
          background: "var(--sa-accent-ink)",
          color: "var(--sa-accent)",
          border: "none",
          padding: "6px 14px",
          fontFamily: "var(--sa-sans)",
          fontSize: 12,
          fontWeight: 500,
          cursor: "pointer",
          borderRadius: 2,
          whiteSpace: "nowrap",
        }}
      >
        Sign up to save this conversation {"->"}
      </button>
    </div>
  );
}
